/* eslint-disable */
require('./doc')
require('./docx')
require('./jpg')
require('./mp3')
require('./pdf')
require('./png')
require('./pptx')
require('./txt')
require('./xls')
require('./xlsx')
require('./zip')
